// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2E3UA","productName":"Table_productName__2Itmm"};